import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const CoupleIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2220_9718)">
          <path
            d="M36.25 36.25V20.5631C36.25 17.4907 33.7593 15 30.6869 15L15 15V20.5631V30.6869C15 33.7593 17.4907 36.25 20.5631 36.25H30.6869H36.25Z"
            fill="#CCF2FB"
          />
          <path
            d="M17.5 18.3333C21.1819 18.3333 24.1667 15.3486 24.1667 11.6667C24.1667 7.98477 21.1819 5 17.5 5C13.8181 5 10.8334 7.98477 10.8334 11.6667C10.8334 15.3486 13.8181 18.3333 17.5 18.3333Z"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 35V31.6667C7.5 29.8986 8.20238 28.2029 9.45262 26.9526C10.7029 25.7024 12.3986 25 14.1667 25H20.8333C22.6014 25 24.2971 25.7024 25.5474 26.9526C26.7976 28.2029 27.5 29.8986 27.5 31.6667V35"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.5 5.21666C28.934 5.58383 30.2051 6.41783 31.1127 7.58718C32.0204 8.75653 32.5131 10.1947 32.5131 11.675C32.5131 13.1553 32.0204 14.5935 31.1127 15.7628C30.2051 16.9322 28.934 17.7662 27.5 18.1333"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M35.8334 35V31.6667C35.8249 30.1953 35.3299 28.768 34.4255 27.6073C33.5211 26.4467 32.2581 25.6178 30.8334 25.25"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2220_9718">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
